// extracted by mini-css-extract-plugin
module.exports = {"component":"podcast-links_component__1nGJD","isOpened":"podcast-links_isOpened__28CuS","links":"podcast-links_links__38KKS","podcastLink":"podcast-links_podcastLink__3CBFw"};